<template>
  <v-card width="100%">
    <v-card-text>
      <user-info :user-data="userData" />
      <v-col cols="12">
        <v-btn
            elevation="7"
            color="#a3ea63"
            x-large
            @click="openShift"
        >
          Открыть смену
        </v-btn>
      </v-col>
    </v-card-text>
    <add-employees v-model="employees" :user-data="userData" />
    <questionnaire @close="showQq = false" qtype="open" :showQq="showQq" @submit="openShiftAndQ" />
  </v-card>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'OpenShift',
  data () {
    return {
      showQq: false,
      employees: [],
    }
  },
  components: {
    questionnaire: () => import('./questionnaire'),
    userInfo: () => import('./openShiftComponents/userInfo'),
    addEmployees: () => import('./openShiftComponents/addEmployees')
  },
  computed: {
    ...mapGetters([
      "userData",
    ]),
  },
  methods: {
    openShiftAndQ (qQsendFn) {
      this.$store.dispatch('shift/openShift', { 'employees': this.employees }).then(()=>{
        if (qQsendFn !== null) qQsendFn()
        window.location.href = "/";
        this.showQq = false
      })
    },
    closeAndNext () {
      window.location.href = "/";
      this.showQq = false
    },
    openShift() {
      this.showQq = true
    },
  }
}
</script>
<style scoped>

</style>
